import { render, staticRenderFns } from "./RoughDiagAnswerItem.vue?vue&type=template&id=6a077de3&scoped=true&"
import script from "./RoughDiagAnswerItem.vue?vue&type=script&lang=js&"
export * from "./RoughDiagAnswerItem.vue?vue&type=script&lang=js&"
import style0 from "./RoughDiagAnswerItem.vue?vue&type=style&index=0&id=6a077de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a077de3",
  null
  
)

export default component.exports